import { ConfigToast, Position } from '../models/ConfigToast';

export function getConfigSuccessToast(detail: string, position: Position = 'bc', life: number = 15000): ConfigToast {
    return new ConfigToast('success', 'Successo', detail, position, life, true);
}

export function getConfigInfoToast(detail: string, position: Position = 'bc', life: number = 15000): ConfigToast {
    return new ConfigToast('info', 'Info', detail, position, life, true);
}

export function getConfigErrorToast(detail: string, position: Position = 'bc', life: number = 15000): ConfigToast {
    return new ConfigToast('error', 'Attenzione', detail, position, life, true);
}

export function getConfigWarnToast(detail: string, position: Position = 'bc', life: number = 15000): ConfigToast {
    return new ConfigToast('warn', '', detail, position, life, true);
}
